import React from 'react';
import { ThumbsDown } from 'lucide-react';
import { getNotifIcon, getNotifColor, formatTimeAgo } from '../lib/notificationHelpers';

const NotificationItem = ({ notif, index, onClick }) => (
  <button
    onClick={() => onClick(notif)}
    className={`w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors border-b border-gray-50 last:border-0 ${
      !notif.read ? 'bg-blue-50/50' : ''
    }`}
    data-testid={`notification-item-${index}`}
  >
    <div className="flex gap-3">
      <div className={`p-1.5 rounded-lg flex-shrink-0 ${getNotifColor(notif.type, notif.decision)}`}>
        {notif.type === 'client_decision' && notif.decision === 'not_interested' 
          ? <ThumbsDown className="h-4 w-4" /> 
          : getNotifIcon(notif.type)}
      </div>
      <div className="min-w-0 flex-1">
        <p className={`text-sm ${!notif.read ? 'font-semibold text-gray-900' : 'text-gray-700'}`}>
          {notif.title}
        </p>
        <p className="text-xs text-gray-500 mt-0.5 line-clamp-2">{notif.message}</p>
        <p className="text-[10px] text-gray-400 mt-1">{formatTimeAgo(notif.created_at)}</p>
      </div>
      {!notif.read && (
        <div className="w-2 h-2 bg-tp-primary rounded-full flex-shrink-0 mt-2" />
      )}
    </div>
  </button>
);

export default NotificationItem;
